import { render, staticRenderFns } from "./ConnectionCard.vue?vue&type=template&id=81679178&"
import script from "./ConnectionCard.vue?vue&type=script&lang=js&"
export * from "./ConnectionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports